module.exports = __webpack_public_path__ + "img/Тендиноз задней группы мышц бедра.29c4a233.jpg";